import { LegalLayout } from './LegalLayout'

export function Privacy() {
  return (
    <LegalLayout title="Privacy Policy" updated="June 15, 2026">
      <p>
        This policy explains what MakerStack collects and how we use it. We aim to collect the
        minimum needed to run the service.
      </p>
      <h2>1. What we collect</h2>
      <p>
        <strong>Account data:</strong> your email and, if you use social sign-in, your basic profile
        from Google or X. <strong>Page content:</strong> the information you choose to publish.{' '}
        <strong>Subscribers:</strong> if you enable email collection, the emails visitors submit are
        stored for you. <strong>Analytics:</strong> privacy-preserving page-view and click counts
        (we do not store raw IP addresses; visitors are counted using a rotating daily hash).
      </p>
      <h2>2. How we use it</h2>
      <p>
        To operate and improve the service, process payments, prevent abuse, and provide your
        analytics. We do not sell your personal data.
      </p>
      <h2>3. Payment processing</h2>
      <p>
        Payments are handled by RevenueCat and Stripe. We never see or store your full card details.
      </p>
      <h2>4. Third parties</h2>
      <p>
        We use service providers for hosting (Convex, Vercel), email (Resend), and error/usage
        analytics. They process data on our behalf under their own terms.
      </p>
      <h2>5. Your rights</h2>
      <p>
        You can edit or delete your page at any time, export your subscribers, and request deletion
        of your account by emailing us. Deleting your account removes your page and associated data.
      </p>
      <h2>6. Contact</h2>
      <p>
        Privacy questions? Email{' '}
        <a href="mailto:privacy@makerstack.altuzar.dev">privacy@makerstack.altuzar.dev</a>.
      </p>
    </LegalLayout>
  )
}
